import { Map } from 'immutable'
import { VNTENDERS_SET_REOPENED_TAB_PAYMENTS } from './ActionTypes'
import { PURGE_ALL_ORDERS } from '../actions/order'
import uuidv4 from 'uuid/v4'

const initialState = () => {
  return Map({
    reopenedTabPayments: Map(),
  })
}

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case VNTENDERS_SET_REOPENED_TAB_PAYMENTS:
      const { orderUuid, payments } = action.payload

      const paymentsMap = Map(
        payments.reduce((acc, payment) => {
          //full offline payments will not have a paymentId then we generate one
          if (!payment.paymentId) {
            payment.paymentId = uuidv4()
          }
          //Filter non CC payments and voided auths (amountInCents === 0)
          //Offline auths return userAttributes.last_4 instead of userAttributes.last4
          if ((!payment.userAttributes?.last4 && !payment.userAttributes.last_4) || payment.amountInCents === 0) {
            return acc
          }

          acc[payment.paymentId] = {
            ...payment,
            userAttributes: {
              ...(payment.userAttributes || {}),
              isOriginalAuth: true,
            },
          }
          return acc
        }, {}),
      )

      return state.setIn(['reopenedTabPayments', orderUuid], paymentsMap)

    case PURGE_ALL_ORDERS: {
      return initialState()
    }

    default:
      return state
  }
}

export default reducer
